import { ResourceLoader } from './resource-loader';
import { Viewer3DBabylon } from './viewer-3d-babylon';
import { Viewer3DContent } from './viewer-3d-content';
import { Viewer3DSync } from './viewer-3d-babylon-sync';
import { MAIN_SCENE } from '../app/types/composition';

export async function generateImage(content: Viewer3DContent, width: number, height: number, fitContent: boolean, animationPercentage: number, loader: ResourceLoader): Promise<Blob> {
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const viewer = new Viewer3DBabylon(canvas, {
        hideReferences: true,
        defaultScene: MAIN_SCENE,
        wireframe: false,
        broadcastEvents: false,
        offscreen: true
    });
    viewer.resize();
    const sync = new Viewer3DSync(viewer, loader, false);
    await sync.sync(content);
    viewer.setCurrentScene(MAIN_SCENE);
    viewer.setAllAnimationPercentages(MAIN_SCENE, animationPercentage, false);
    viewer.useOrbitCamera(MAIN_SCENE);
    if(fitContent) {
        viewer.fitContent(MAIN_SCENE, true);
    }
    await viewer.render(MAIN_SCENE);


    const blob = await canvasToBlob(canvas, 'image/jpeg', 1);
    viewer.dispose();
    canvas.remove();
    return blob;
}

async function timeoutP(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function canvasToBlob(canvas: HTMLCanvasElement|OffscreenCanvas, type: string, quality: number): Promise<Blob> {
    if(canvas instanceof HTMLCanvasElement) {
        return new Promise((resolve, reject) => canvas.toBlob(blob => {
            if(blob) {
                resolve(blob);
            } else {
                reject(new Error('Failed to generate image'));
            }
        }, type, quality));    
    } else {
        return canvas.convertToBlob({ type, quality });
    }
}